import { makeActions } from '@redux/crudCreator/actions';
import { apiWrapper } from '@redux/crudCreator/reduxUtils';
import { GetAllPayloadType } from '@redux/crudCreator/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSummaryInventoriesApi } from 'api/locationStocks';

export const MODEL_NAME = 'inventories';
export const inventoriesActions = makeActions(MODEL_NAME);

export const getAllInventories = inventoriesActions.getAll;
export const editInventories = inventoriesActions.edit;
export const createInventories = inventoriesActions.create;
export const getByIdInventories = inventoriesActions.getDataById;

export const getSummaryInventories = createAsyncThunk(
  'inventories/getSummaryInventories',
  async (payload: GetAllPayloadType, thunkAPI) => {
    // const { data } = payload;

    try {
      const response = await apiWrapper(null, getSummaryInventoriesApi);
      if (response) {
        return response;
      }
      return thunkAPI.rejectWithValue({ error: true, data: response });
    } catch (error) {
      return thunkAPI.rejectWithValue({ data: error, error: true });
    }
  },
);
